// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2644W","left":"styles_left__1wGR8","desktopActions":"styles_desktopActions__zgqtA","title":"styles_title__1B6yU"};